import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  rootFrameService: {
    maxWidth: '281px',
    height: '457px',
    borderRadius: '44px',
    border: '2px solid #BBBBBA',
    background: theme.palette.background.default,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 20,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      maxWidth: '100%',
    },
    [theme.breakpoints.down('md')]: {
      height: '100%',
    },
  },
  cardContentImage: {
    padding: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardContentBodyImage: {
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageFrameService: {
    width: '69px',
    height: '63px',
    opacity: '1',
  },

  subtitleFrame: {
    fontFamily: 'Montserrat',
    fontSize: ' 25px',
    fontWeight: 700,
    lineHeight: '40px',
    textAlign: 'center',
  },
  bodyFrame: {
    opacity: '1',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '25.6px',
    textAlign: 'center',
    paddingBottom: '10px',
  },
  fixedButton: {
    position: 'absolute',
    bottom: '10px',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  cardActionsButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingBottom: '10px',
    marginTop: theme.spacing(3),
  },
}));

export default useStyles;
